import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import FarceActions from 'farce/Actions';
import { bindActionCreators } from 'redux';
var NAVIGATION_ACTION_CREATORS = {
  push: FarceActions.push,
  replace: FarceActions.replace,
  go: FarceActions.go
};
export default function createStoreRouterObject(store) {
  var farce = store.farce,
      found = store.found;
  var matcher = found.matcher;
  return _extends({}, bindActionCreators(NAVIGATION_ACTION_CREATORS, store.dispatch), {}, farce, {}, found, {
    // Expose isActive from matcher directly for convenience. This pattern is
    // faster than using matcher.isActive.bind(matcher).
    isActive: function isActive(match, location, options) {
      return matcher.isActive(match, location, options);
    }
  });
}